var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59322 0.330415C7.77898 0.534744 7.76392 0.850968 7.55959 1.03672L2.64989 5.50008H14.0233C14.2994 5.50008 14.5233 5.72394 14.5233 6.00008C14.5233 6.27623 14.2994 6.50008 14.0233 6.50008H2.64989L7.55959 10.9634C7.76392 11.1492 7.77898 11.4654 7.59322 11.6698C7.40747 11.8741 7.09124 11.8891 6.88691 11.7034L0.613281 6.00008L6.88691 0.296782C7.09124 0.111028 7.40747 0.126086 7.59322 0.330415Z",
    fill: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.1a5381b343574113fdda1bb089b8b9c7.svg";
export { ForwardRef as ReactComponent };